export const state = () => ({
  profileCompletion: null,
  profileCompletionList: [],
  loading: 0,
  pointOfSaleList: [],
  modelLanguageList: [],
  options: [],
  groupList: [],
  selectedPointOfSaleGuid: undefined,
  moduleStatus: false,
});
